import cookieData from './cookie-data';
// import 'magnific-popup';
export function openPopup () {
	const $openPopup = $('[data-open-popup]');
	if (window.popUp) {
		const popUp = window.popUp;
		if (popUp['pop_up'] && popUp.showPopUp === false) {
			setTimeout(function () {
				const mfpInstance = $.magnificPopup ? $.magnificPopup.instance : false;
				if (mfpInstance) {
					if (!mfpInstance.isOpen) {
						$(document).on('galleryClosed', function () {
							deferOpen();
						});
						$(document).trigger('galleryClose');
					}
				} else {
					deferOpen();
				}
				if (!cookieData.receive('show_PopUp')) {
					cookieData.add('show_PopUp', true, {path: '/'});
				}
			}, popUp.time * 1000);
		}
	} else {
		$openPopup.on('click', function () {
			window.location.href = '#form';
		});
		let url = window.location.href.split('#');
		const param = url[url.length - 1].toString();

		if ($('#call_me').find($openPopup).length) {
			if (param === 'form') {
				$('#call_me').find($openPopup)[0].click();
			}
		}
	}

	function deferOpen () {
		$('#deferred-popup').find($openPopup)[0].click();
	}
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/open-popup.js